import { render, staticRenderFns } from "./Index-Budget.vue?vue&type=template&id=1dbeee2c&scoped=true"
import script from "./Index-Budget.vue?vue&type=script&lang=js"
export * from "./Index-Budget.vue?vue&type=script&lang=js"
import style0 from "./Index-Budget.vue?vue&type=style&index=0&id=1dbeee2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbeee2c",
  null
  
)

export default component.exports